const MESSAGES = {
  PASSWORD_SHORT_ERROR: 'Your password must be at least 8 characters long.',
  PASSWORD_INVALID_ERROR: 'Please enter a valid password.',
  PASSWORD_DIDNT_MATCH_ERROR: 'Passwords did not match.',
  RESET_PASSWORD_EMAIL_SENT: 'Reset password email sent.',
  RESET_PASSWORD_EMAIL_SENT_SELF: 'Reset password email sent. Please check your email inbox.',
  LOGGED_IN_SUCCESSFULLY: 'Logged in successfully.',
  USER_SAVED: 'User Saved.',
  USER_ADDED: 'User Added.',
  USER_DELETED: 'User Deleted.',
  TWO_FACTOR_RESET: 'Two factor authorisation has been removed',
  APPROVE_CHANGE: 'Are you sure you want to approve this change?',
  REJECT_CHANGE: 'Are you sure you want to reject this change?',
  PROJECT_ADDED: 'Project added successfully!',
  PROJECT_UPDATED: 'Project updated successfully!',
  ROLE_ADDED: 'Role added successfully!',
  ROLE_DELETED: 'Role deleted successfully!',
  ROLE_UPDATED: 'Role updated successfully!',
};
export default MESSAGES;
